<template>
  <div>
    <DashboardProducerOrders v-if="!isMarket" />
    <DashboardProducerPlan v-if="!isMarket" />
    <DashboardProducerPP v-if="!isMarket" />
    <DashboardMarketOrders v-if="isMarket" />
    <DashboardMarketPlan v-if="isMarket" />
    <DashboardMarketPP v-if="isMarket" />
  </div>
</template>

<script>
import DashboardProducerOrders from "../../role/DashboardProducerOrders.vue";
import DashboardProducerPlan from "../../role/DashboardProducerPlan.vue";
import DashboardProducerPP from "../../role/DashboardProducerPP.vue";
import DashboardMarketPlan from "../../role/DashboardMarketPlan.vue";
import DashboardMarketPP from "../../role/DashboardMarketPP.vue";
import DashboardMarketOrders from "../../role/DashboardMarketOrders.vue";

export default {
  components: {
    DashboardProducerOrders,
    DashboardProducerPlan,
    DashboardProducerPP,
    DashboardMarketPlan,
    DashboardMarketPP,
    DashboardMarketOrders,
  },
  props: {
    isMarket: { type: Boolean, default: false },
  },
  data() {
    return {};
  },
};
</script>
